import type { TypographyOptions } from '@mui/material/styles/createTypography';

/**
 * Typography scale tuned for booking UIs — large hero numbers (rates),
 * dense card metadata, and readable long-form descriptions.
 *
 * Stack uses Inter (loaded via Google Fonts in each app's index.html)
 * with a Roboto fallback to mirror MakeMyTrip's clean sans-serif feel.
 */
export const FONT_FAMILY = ['"Inter"', '"Roboto"', '"Helvetica Neue"', 'Arial', 'sans-serif'].join(
  ', ',
);

export const typography: TypographyOptions = {
  fontFamily: FONT_FAMILY,
  fontSize: 14,
  htmlFontSize: 16,
  h1: {
    fontFamily: FONT_FAMILY,
    fontWeight: 700,
    fontSize: '2.5rem',
    lineHeight: 1.2,
    letterSpacing: '-0.02em',
  },
  h2: {
    fontFamily: FONT_FAMILY,
    fontWeight: 700,
    fontSize: '2rem',
    lineHeight: 1.25,
    letterSpacing: '-0.015em',
  },
  h3: { fontFamily: FONT_FAMILY, fontWeight: 700, fontSize: '1.5rem', lineHeight: 1.3 },
  h4: { fontFamily: FONT_FAMILY, fontWeight: 600, fontSize: '1.25rem', lineHeight: 1.35 },
  h5: { fontFamily: FONT_FAMILY, fontWeight: 600, fontSize: '1.125rem', lineHeight: 1.4 },
  h6: { fontFamily: FONT_FAMILY, fontWeight: 600, fontSize: '1rem', lineHeight: 1.45 },
  subtitle1: { fontWeight: 500, fontSize: '1rem', lineHeight: 1.5 },
  subtitle2: { fontWeight: 500, fontSize: '0.875rem', lineHeight: 1.5 },
  body1: { fontSize: '1rem', lineHeight: 1.55 },
  body2: { fontSize: '0.875rem', lineHeight: 1.55 },
  button: { fontWeight: 600, fontSize: '0.9375rem', textTransform: 'none', letterSpacing: 0.2 },
  caption: { fontSize: '0.75rem', lineHeight: 1.5, color: '#4A4A4A' },
  overline: { fontWeight: 600, fontSize: '0.6875rem', letterSpacing: '0.08em' },
};
